"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var models_1 = require("./models");
var ChangeIndicator_1 = require("../../overview/ChangeIndicator/ChangeIndicator");
var ContextMenu_1 = __importDefault(require("../ContextMenu"));
var Actions_1 = __importDefault(require("../Actions"));
var Checkbox_1 = __importDefault(require("../Checkbox"));
var Icon_1 = __importDefault(require("../Icon"));
var MorningStar_1 = __importDefault(require("../MorningStar"));
var Link_1 = __importDefault(require("../Link"));
var Translate_1 = __importDefault(require("../Translate"));
var ToggleButton_1 = __importDefault(require("../ToggleButton"));
var Color_1 = __importDefault(require("../Color"));
var Scale_1 = __importDefault(require("../Scale"));
var WeightingBar_1 = require("../WeightingBar/WeightingBar");
var ScaleLegend_1 = __importDefault(require("../ScaleLegend"));
var TableLogicBase_1 = require("./TableLogicBase");
var isNullOrUndefined = ksys_app_template_1.utils.typeChecks.isNullOrUndefined;
var TableLogic = /** @class */ (function (_super) {
    __extends(TableLogic, _super);
    function TableLogic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableLogic.prototype.getValue = function (row, column, translationContext, rowComponent, table, cellDescribedby) {
        var _this = this;
        var value = this.getRawValue(row, column);
        var response = this.formatValueForColumn(value, column, translationContext);
        var display = this.getColumnDisplay(column);
        var type = display.type, _a = display.options, options = _a === void 0 ? {} : _a;
        var superscripts = this.getCellSuperscripts(column, row);
        if (type === models_1.TableColumnDisplayType.contextMenu &&
            options.contextMenu) {
            response = react_1.default.createElement(ContextMenu_1.default, __assign({}, options.contextMenu, { payload: row }));
        }
        else if (type === models_1.TableColumnDisplayType.actions && options.actions) {
            options.actions.buttons.forEach(function (button) {
                button.payload = row;
            });
            response = react_1.default.createElement(Actions_1.default, __assign({}, options.actions));
        }
        else if (type === models_1.TableColumnDisplayType.checkbox &&
            options.checkbox) {
            var onChange = function (event) {
                var value = event.target.checked;
                if (options.checkbox && options.checkbox.onChange) {
                    options.checkbox.onChange(row, value);
                }
                if (column.key === '_selected' &&
                    table &&
                    table.rowSelectionChange) {
                    table.rowSelectionChange(value, row);
                }
            };
            response = (react_1.default.createElement(Checkbox_1.default, __assign({ value: !!value }, options.checkbox, { onChange: onChange })));
        }
        else if (type === models_1.TableColumnDisplayType.icon && options.icon) {
            response = react_1.default.createElement(Icon_1.default, __assign({}, options.icon));
        }
        else if (type === models_1.TableColumnDisplayType.morningstarRating &&
            options.morningstarRating) {
            response = (react_1.default.createElement(MorningStar_1.default, __assign({}, options.morningstarRating, { morningStarRating: parseInt(value, 10) })));
        }
        else if (type === models_1.TableColumnDisplayType.color) {
            response = react_1.default.createElement(Color_1.default, __assign({}, (options.color || {}), { color: value }));
        }
        else if (type === models_1.TableColumnDisplayType.scale && options.scale) {
            response = (react_1.default.createElement(Scale_1.default, __assign({}, (options.scale || {}), { value: parseInt(value, 10) })));
        }
        else if (type === models_1.TableColumnDisplayType.expander &&
            options.expander) {
            response = (react_1.default.createElement(ToggleButton_1.default, __assign({}, options.expander, { onChange: function (active) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        row._expanded = active;
                        if (rowComponent) {
                            rowComponent.toggleExpanded(active);
                            if (active) {
                                rowComponent.onExpand(row);
                            }
                            else {
                                rowComponent.onCollapse(row);
                            }
                        }
                        return [2 /*return*/];
                    });
                }); }, active: row._expanded, loading: rowComponent && rowComponent.fetchingChildren, buttonProps: {
                    describedby: cellDescribedby,
                }, iconActive: {
                    asset: 'base.toggleButton.active',
                    accessibilityText: 'Collapse',
                }, iconInactive: {
                    asset: 'base.toggleButton.inactive',
                    accessibilityText: 'Expand',
                }, suppressAnalytics: true })));
        }
        else if (type === models_1.TableColumnDisplayType.link && options.link) {
            var _b = options.link, redirect = _b.redirect, conditional = _b.conditional;
            var props = {};
            if (redirect) {
                var allowLink = true;
                if (conditional) {
                    var conditionalHelper = new ksys_app_template_1.helpers.ConditionalHelper(conditional, this.translationHelper);
                    allowLink = conditionalHelper.matches({
                        row: row,
                        column: column,
                        value: value,
                    });
                }
                if (allowLink) {
                    if (redirect) {
                        var redirectHelper = new ksys_app_template_1.helpers.RedirectHelper(window.location.href);
                        var redirectPath = redirectHelper.getRedirectPath(redirect, { row: row, column: column, value: value });
                        props.href = redirectPath;
                    }
                    response = (react_1.default.createElement(Link_1.default, __assign({}, props),
                        react_1.default.createElement(Translate_1.default, null, response)));
                }
            }
            if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(response)) {
                response = column.placeholder || this.props.placeholder;
            }
        }
        else if (type === models_1.TableColumnDisplayType.weightingBar &&
            options.weightingBar) {
            var weightingBlocksConfig_1 = options.weightingBar.weightingBlocks;
            var weightingBarProps = {
                weightingBlocks: value.map(function (val, idx) {
                    var weightingBlock = weightingBlocksConfig_1[idx];
                    var block = { value: val };
                    if (weightingBlock) {
                        Object.assign(block, weightingBlock);
                    }
                    return block;
                }),
            };
            response = react_1.default.createElement(WeightingBar_1.WeightingBar, __assign({}, weightingBarProps));
        }
        else {
            if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(response)) {
                response = column.placeholder || this.props.placeholder;
            }
            else if (type === models_1.TableColumnDisplayType.changeIndicator &&
                options.changeIndicator) {
                var changeIndicatorProps = Object.assign({}, options.changeIndicator, { superscripts: superscripts, value: response });
                var directionValue = changeIndicatorProps.directionValue;
                if (directionValue &&
                    !ksys_app_template_1.utils.typeChecks.isNumber(parseInt(directionValue, 10))) {
                    changeIndicatorProps.directionValue = this.getRawValue(row, { id: '', key: directionValue });
                }
                response = react_1.default.createElement(ChangeIndicator_1.ChangeIndicator, __assign({}, changeIndicatorProps));
            }
        }
        return response;
    };
    TableLogic.prototype.getHeaderValue = function (headerDisplay) {
        var type = headerDisplay.type, _a = headerDisplay.options, options = _a === void 0 ? {} : _a;
        var response;
        if (type === models_1.TableColumnHeaderDisplayType.scaleLegend &&
            options.scaleLegend) {
            response = react_1.default.createElement(ScaleLegend_1.default, __assign({}, options.scaleLegend));
        }
        else if (type === models_1.TableColumnHeaderDisplayType.weightingBar &&
            options.weightingBar) {
            response = react_1.default.createElement(WeightingBar_1.WeightingBar, __assign({}, options.weightingBar));
        }
        return response;
    };
    return TableLogic;
}(TableLogicBase_1.TableLogicBase));
exports.TableLogic = TableLogic;
